import {ApplicationConfig} from '@angular/core';
import {provideRouter} from '@angular/router';

import {routes} from '@shared/services/router/app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {provideToastr} from 'ngx-toastr';
import {SampleInterceptor} from '@shared/services/security/log.interceptor';
import {provideQuillConfig} from "ngx-quill";
import {provideNgIdle} from "@ng-idle/core";
import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";
import {createAppErrorHandler} from '@shared/utils/app-error-handler';

export const appConfig: ApplicationConfig = {
    providers: [
        {
            provide: ErrorHandler,
            useValue: createAppErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            useFactory: () => () => {},
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => {},
            deps: [Sentry.TraceService],
            multi: true,
        },
        provideRouter(routes),
        // provideHttpClient(withInterceptors([authInterceptor,logInterceptor])),
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SampleInterceptor,
            multi: true
        },
        provideClientHydration(),
        provideAnimationsAsync(),
        provideNgIdle(),
        provideToastr(),
        provideQuillConfig({
            modules: {
                syntax: false,
                // toolbar: [...]
            }
        })
    ],
};
